export default __webpack_public_path__ + "static/media/icon-upload-logo.1e91ee94.svg";